export const enviroment = {
    production: false,
    apiUrl: 'https://apilogdev.meds.cl'
}